<template>
	<div>
		<div>
			<h3 class="mb-3">Moja naročila</h3>
			<div class="vx-row mt-6">
				<div class="vx-col lg:w-1/2 w-full mb-3" v-for="order in orders" :key="order.id">

					<vx-card :title="moment(order.order_time).format('DD/MM/YYYY HH:mm')">
						<p><b>Telefonska številka:</b> {{order.phone_number}}</p>
						<p><b>Naslov:</b> {{order.address}}</p>
						<p><b>Tip plačila:</b> {{order.payment_type}}</p>
						<p><b>Cena jedi:</b> {{order.food_price.toFixed(2)}} &euro;</p>
						<p><b>Cena dostave:</b> {{order.shipping_price.toFixed(2)}} &euro;</p>
						<p class="mb-6"><b>Skupna cena:</b> {{order.total_price.toFixed(2)}} &euro;</p>

						<p class="mb-6"><b style="float: left" class="mt-1">Stanje naročila:</b>
							<vs-chip class="ml-3" v-if="order.status === 1" color="#f1c40f">Čakanje na potrditev plačila</vs-chip>
							<vs-chip class="ml-3" v-if="order.status === 2" color="warning">Čakanje na prevzem</vs-chip>
							<vs-chip class="ml-3" v-if="order.status === 3" color="#6c5ce7">Naročilo potrjeno</vs-chip>
							<vs-chip class="ml-3" v-if="order.status === 4" color="success">Naročilo zaključeno</vs-chip>
							<vs-chip class="ml-3" v-if="order.status === 5" color="danger">Naročilo preklicano</vs-chip>
						</p>

						<div style="clear: both" class="mb-6"></div>

						<h4>Jedi</h4>
						<div class="ml-3 vx-row">
							<div v-for="(item, index) in order.items" :key="order.id + '-' + index" class="mb-6 vx-col w-1/2">
								<h6 class="mt-3">- {{item.food_name}}</h6>
								<div class="ml-6">
									<p v-if="item.additional_comment.length > 0"><b>Dodatni opis:</b> {{item.additional_comment}}</p>
									<p><b>Količina:</b> {{item.quantity}}</p>
									<p><b>Cena:</b> {{item.price.toFixed(2)}} &euro;</p>
									<p v-for="(value, key) in item.options" :key="key"><b>{{key}}:</b> {{value}}</p>
									<p v-if="item.additions.length > 0"><b>Dodatki</b></p>
									<div class="ml-6" v-if="item.additions.length > 0">
										<div class="vx-row" v-for="(addition, index) in item.additions" :key="index">
											<div v-if="addition.charAt(0) === '-'">
												<feather-icon svgClasses="fill-current text-danger" icon="XIcon" style="float: left" />
												<p class="ml-2" style="float: left">{{addition.substring(2, addition.length)}}</p>
											</div>
											<div v-else>
												<feather-icon svgClasses="stroke-current text-success" icon="CheckIcon" style="float: left" />
												<p class="ml-2" style="float: left">{{addition}}</p>
											</div>

										</div>

									</div>
								</div>
							</div>
						</div>
					</vx-card>

				</div>
			</div>
		</div>
		<vs-divider/>
		<div>
			<h3 class="mb-3">Naslovi</h3>
			<vs-button color="primary" @click="addAddressPromptActive = true">Dodaj naslov</vs-button>
			<div class="vx-row mt-6">
				<div class="vx-col xl:w-1/3 lg:w-1/3 w-full mb-3" v-for="addressItem in addresses" :key="addressItem.id">

					<vx-card :title="addressItem.title">
						<p>Naslov: {{addressItem.address}}</p>
						<p>Mesto: {{addressItem.town}}</p>
						<p>Država: {{addressItem.country}}</p>

						<vs-button class="mt-3" color="primary" @click="removeAddress(addressItem.id)">Izbriši</vs-button>
					</vx-card>

				</div>
			</div>

			<vs-popup title="Dodaj naslov" :active.sync="addAddressPromptActive">
				<div>
					<p class="mt-6">Ime naslova (lahko vidite samo vi. Primer: Dom, Služba itd..)</p>
					<vs-input v-model="addTitle" style="width: 100%"></vs-input>
					<p class="mt-6">Naslov (Ulica in hišna številka)</p>
					<vs-input v-model="addAddressAddress" style="width: 100%"></vs-input>
					<p class="mt-6">Mesto</p>
					<vs-input v-model="addTown" style="width: 100%"></vs-input>
					<p class="mt-6">Država</p>
					<vs-input v-model="addCountry" style="width: 100%"></vs-input>
					<vs-divider/>
					<h6>Polni naslov (naslov more bit mogoče najt na Google Maps v tej obliki):</h6>
					<p class="mt-6">{{addAddressAddress}}<span v-if="addAddressAddress.length > 0 && addTown.length > 0">,</span> {{addTown}}<span v-if="addTown.length > 0 && addCountry.length > 0">,</span> {{addCountry}}</p>
					<vs-divider/>
					<vs-button color="success" class="mt-6; mr-1" @click="addAddress">Dodaj</vs-button>
				</div>
			</vs-popup>
		</div>
	</div>
</template>
<script>

	export default {
		data(){
			return {

				addresses: null,

				addAddressPromptActive: false,
				addTitle: '',
				addAddressAddress: '',
				addTown: '',
				addCountry: '',

				orders: null,

				updateOrdersTimer: '',
			}
		},
		methods: {
			updateOrders(){
				const thisIns = this;
				this.$http.get('/api/order/v1/orders')
						.then(function (response) {
							thisIns.orders = response.data;
						}).catch(function (error) {
					thisIns.$vs.notify({
						title:'Error',
						text: error,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			updateAddresses(){
				const thisIns = this;
				this.$http.get('/api/order/v1/address')
						.then(function (response) {
							thisIns.addresses = response.data;
						}).catch(function (error) {
					thisIns.$vs.notify({
						title:'Error',
						text: error,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			addAddress(){
				this.$vs.loading();
				const thisIns = this;
				this.$http.post('/api/order/v1/address', {
					address: this.addAddressAddress,
					town: this.addTown,
					country: this.addCountry,
					title: this.addTitle
				})
						.then(function () {
							thisIns.$vs.loading.close();
							thisIns.addAddressPromptActive = false;
							thisIns.updateAddresses();
							thisIns.addAddressAddress = '';
							thisIns.addTown = '';
							thisIns.addCountry = '';
							thisIns.addTitle = '';
						}).catch(function (error) {
					thisIns.$vs.loading.close();
					thisIns.$vs.notify({
						title:'Napaka',
						text: "Naslov " + thisIns.addAddressAddress + ", " + thisIns.addTown + ", " + thisIns.addCountry + " ni najden v Google Maps!",
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			removeAddress(id){
				const thisIns = this;
				this.$vs.loading();
				this.$http.delete('/api/order/v1/address/' + id)
						.then(function () {
							thisIns.updateAddresses();
							thisIns.$vs.loading.close();
						}).catch(function (error) {
					thisIns.$vs.loading.close();
					thisIns.$vs.notify({
						title:'Error',
						text: "Napaka",
						color:'Ni mogoče izbrisat naslova!',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
		},
		beforeDestroy(){
			clearInterval(this.updateOrdersTimer);
		},
		created() {
			this.updateAddresses();
			this.updateOrders();
			this.updateOrdersTimer = setInterval(()=>{ this.updateOrders() }, 1000);
		}
	}

</script>
